import dayjs from 'dayjs';

import { getWithInstallValue } from '@r1-frontend/service-engineer-visit/helpers';
import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getBodyForTimeSlotsRequest = (state: TInitialState, dateFrom: Date | string, dateTo: Date | string, productId: number | undefined = 0) => {
    if (!state._incomingData) {
        throw new Error('Incoming data is not set');
    }

    const result = {
        dateFrom: dateFrom instanceof Date ? dayjs(dateFrom).format('DD.MM.YYYY') : dateFrom,
        dateTo: dateTo instanceof Date ? dayjs(dateTo).format('DD.MM.YYYY') : dateTo,
        agreementId: state._incomingData.contractId,
        saleAgentClientName: state._incomingData.clientName,
        withInstall: getWithInstallValue(state),
        buyProduct: productId,
    };

    if (state._incomingData.productId) {
        result['buyProduct'] = state._incomingData.productId;
    }

    return result;
};

export default getBodyForTimeSlotsRequest;
